import Content from "../../../components/Content"
import PlayerStatItem from "../../../components/PlayerStatItem"
import { useEffect, useState } from "react"
import SeasonPlayerStatsInterface from "../../../interfaces/SeasonPlayerStats.interface"
import { convertSecondsToTime } from "../../../utils/time"
import { useAppSelector } from "../../../store/store"
import PlayerStats from "../../../interfaces/PlayerStats.interface"

const PlayerOverviewPage = () => {
    const player = useAppSelector(state => state.playerPage)
    const [historical, setHistorical] = useState<PlayerStats>()
    const [currentSeason, setCurrentSeason] = useState<PlayerStats>()

    const handleChangeSeason: React.ChangeEventHandler<HTMLSelectElement> = (event) => {
        const seasonName = event.target.value

        const season = player?.player_stats?.find(stats => stats.season?.name === seasonName)

        setCurrentSeason(season)
    }

    useEffect(() => {
        if (player.player_stats && player?.player_stats?.length > 0) {
            setCurrentSeason(player?.player_stats?.filter((stats) => stats.type !== "HISTORIC")[0])
            setHistorical(player?.player_stats?.find((stats) => stats.type === "HISTORIC"))
        }
    }, [player])

    return (
        <>
            <p className="text-4xl text-zinc-700 pl-32 pt-10">Estadísticas</p>
            <Content className="grid grid-cols-1 md:grid-cols-2 gap-10">
                <div className="flex flex-col gap-5">
                    <p className="text-2xl text-zinc-700">Históricas</p>
                    <PlayerStatItem label="Calidad" value={historical?.base_stats?.quality?.toFixed(2)} />
                    <PlayerStatItem label="Partidos jugados" value={historical?.base_stats?.matches_played} />
                    <PlayerStatItem label="Partidos ganados" value={historical?.base_stats?.matches_won} />
                    <PlayerStatItem label="Partidos perdidos" value={historical?.base_stats?.matches_lost} />
                    <PlayerStatItem label="Partidos Abandonados" value={historical?.base_stats?.matches_abandoned} />
                    <PlayerStatItem label="Goles" value={historical?.base_stats?.goals} />
                    <PlayerStatItem label="Goles en contra" value={historical?.base_stats?.goals_against} />
                    <PlayerStatItem label="Goles por partido" value={Number(historical?.base_stats?.matches_played) > 0 ? (Number(historical?.base_stats?.goals) / Number(historical?.base_stats?.matches_played)).toFixed(2) : 0} />
                    <PlayerStatItem label="Asistencias" value={historical?.base_stats?.assists} />
                    <PlayerStatItem label="Jugadas colectivas" value={historical?.base_stats?.team_plays} />
                    <PlayerStatItem label="Toques" value={historical?.base_stats?.kicks} />
                    <PlayerStatItem label="Pases" value={historical?.base_stats?.passes} />
                    <PlayerStatItem label="Efectividad" value={`${((Number(historical?.base_stats?.passes) / Number(historical?.base_stats?.kicks)) * 100).toFixed(2)}%`} />
                    <PlayerStatItem label="Tiempo jugado" value={convertSecondsToTime(historical?.base_stats?.time_played as number)} />
                </div>
                <div className="flex flex-col gap-5">
                    <div className="flex items-center gap-5">
                        <p className="text-2xl text-zinc-700">Temporada</p>
                        <select onChange={handleChangeSeason}>
                            {player?.player_stats?.filter((stats) => stats.type !== "HISTORIC").map((stats) => {
                                return (
                                    <option key={`${stats.player_id}${stats.season_id}`} value={stats.season?.name}>{stats.season?.name}</option>
                                )
                            })}
                        </select>
                    </div>
                    <PlayerStatItem label="Calidad" value={currentSeason?.base_stats?.quality?.toFixed(2)} />
                    <PlayerStatItem label="Partidos jugados" value={currentSeason?.base_stats?.matches_played} />
                    <PlayerStatItem label="Partidos ganados" value={currentSeason?.base_stats?.matches_won} />
                    <PlayerStatItem label="Partidos perdidos" value={currentSeason?.base_stats?.matches_lost} />
                    <PlayerStatItem label="Partidos Abandonados" value={currentSeason?.base_stats?.matches_abandoned} />
                    <PlayerStatItem label="Goles" value={currentSeason?.base_stats?.goals} />
                    <PlayerStatItem label="Goles en contra" value={currentSeason?.base_stats?.goals_against} />
                    <PlayerStatItem label="Goles por partido" value={Number(currentSeason?.base_stats?.matches_played) > 0 ? (Number(currentSeason?.base_stats?.goals) / Number(currentSeason?.base_stats?.matches_played)).toFixed(2) : 0} />
                    <PlayerStatItem label="Asistencias" value={currentSeason?.base_stats?.assists} />
                    <PlayerStatItem label="Jugadas colectivas" value={currentSeason?.base_stats?.team_plays} />
                    <PlayerStatItem label="Toques" value={currentSeason?.base_stats?.kicks} />
                    <PlayerStatItem label="Pases" value={currentSeason?.base_stats?.passes} />
                    <PlayerStatItem label="Efectividad" value={`${((Number(currentSeason?.base_stats?.passes) / Number(currentSeason?.base_stats?.kicks)) * 100).toFixed(2)}%`} />
                    <PlayerStatItem label="Tiempo jugado" value={convertSecondsToTime(currentSeason?.base_stats?.time_played as number)} />
                </div>
            </Content>
        </>
    )
}

export default PlayerOverviewPage